<template>
  <div
    class="flex flex-col w-full lg:w-5/6 ml-auto mr-auto borderRadius border p-12 mt-20 mb-12 justify-around items-center border-grayBorder relative">
    <div class="flex absolute -top-6">
      <button class="w-32 text-sm" :class="{ 'btn-primary': isAwardsVisible, 'default-awards': !isAwardsVisible }"
        @click="showAwards">AWARDS</button>
      <button class="w-44 ml-3 text-sm"
        :class="{ 'btn-primary': isCertificationsVisible, 'default-awards': !isCertificationsVisible }"
        @click="showCertifications">CERTIFICATIONS</button>
    </div>
    <div class="flex justify-between gap-6 max-md:justify-around items-center w-full flex-wrap">
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Top PHP_dark.jpg" class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/top php award.jpg" class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Web development_dark.jpg"
          class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/Web development award.jpg"
          class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Top mobile developers_dark.jpg"
          class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/Top mobile developers.jpg"
          class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Top software developers_dark.jpg"
          class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/Top software developers.jpg"
          class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Top web development company_dark.jpg"
          class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/Top web development company.jpg"
          class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isAwardsVisible">
        <img alt="awards" data-src="../../../images/awards/Top React_dark.jpg" class="gray-awards w-[134px] lazyload" />
        <img alt="awards" data-src="../../../images/awards/Top react award.jpg"
          class="colored-awards w-[134px] lazyload" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/Vue-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/Vue-certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/AWS-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/AWS-certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/Symfony-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/Symfony-certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/React-Native-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/React-Native-Certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/MongoDB-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/MongoDB-certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
      <div class="image-awards-container" v-show="isCertificationsVisible">
        <img alt="certification" data-src="../../../images/certifications/Node-certificate.jpg"
          class="lazyload gray-awards w-[134px]" />
        <img alt="certification" data-src="../../../images/certifications/Node-certificate-color.jpg"
          class="lazyload colored-awards w-[134px]" />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Awards",
  data() {
    return {
      isAwardsVisible: true,
      isCertificationsVisible: false
    };
  },
  methods: {
    showAwards() {
      this.isAwardsVisible = true;
      this.isCertificationsVisible = false;
    },
    showCertifications() {
      this.isAwardsVisible = false;
      this.isCertificationsVisible = true;
    }
  }
};
</script>

<style scoped>
.image-awards-container {
  position: relative;
}

.image-awards-container:hover .colored-awards {
  opacity: 1;
}

.gray-awards {
  height: auto;
}

.colored-awards {
  position: absolute;
  height: auto;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}</style>
